import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Route, BrowserRouter as Router } from 'react-router-dom';
import Google from "./Google";
import Disclaimers from "./Disclaimers";
import Docs from './Docs';
import Category from './Category';
import Quotes from './Quotes';

class App extends Component {
  removeHeaderBtn = () => {this.setState({headerBtnVisible:false})};


  google_login = (response) => {
    console.log(response);
    // https://developers.google.com/identity/gsi/web/guides/display-google-one-tap#credential_response
    function decodeJwtResponse(token) {
      let base64Url = token.split('.')[1];
      let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      let jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      }).join(''));

      return JSON.parse(jsonPayload);
    }
    let decoded = decodeJwtResponse(response.credential);
    this.setState({
      googlechecked:true,
      credential:response.credential,
      sub:decoded.sub
    });
  }  

  google_ready = () => {
    console.log("ready");
    if (!this.state.googlechecked) {
      // https://developers.google.com/identity/gsi/web/reference/js-reference
      window.google.accounts.id.initialize({
        client_id: '235022023955-tll203hk1otnjji8ih27lnj5hcvms51l.apps.googleusercontent.com',
        callback: this.google_login,
        color_scheme: 'dark',
        auto_select: true
      });
      ///window.google.accounts.id.prompt();
      //window.google.accounts.id.prompt((notification) => {
      //  console.log(notification.getMomentType());
      //});
    }
  };

  constructor(props) {
    super(props);
    
    this.state = {
      credential:null,
      googlechecked:false,
      listError:null,
      listLoaded:false,
      list: {},
      headerBtnVisible:true,
      moonPhase:null
    };
    window.google_login = this.google_login;
  }
  

  componentDidMount() { 
  
    if (!document.getElementById('google-gsi-client')) {
      let js = document.createElement('script'); js.id = 'google-gsi-client';
      js.src = "https://accounts.google.com/gsi/client";
      js.onload = this.google_ready;
      js.async = true;
      let fjs = document.getElementsByTagName('script')[0];
      fjs.parentNode.insertBefore(js, fjs);
    }
    
    fetch("https://moreygenetics.com/json/list.json")
      .then(res=>res.json())
      .then(
        (result) => {
          this.setState({
            listLoaded:true,
            list:result
          });
        }, 
        (error) => {
          console.log(error);
          this.setState({
            listLoaded:true,
            listError:error
          });
        }
      );
      
    fetch("https://moreygenetics.com/api/moonphase.py")
      .then(result=>result.text())
      .then((result)=>{
        this.setState({moonPhase:result});
      });
  }
  

  render() {
    // Import all image files in "./images/" into an object
    function importAll(r) {
      let images = {};
      r.keys().forEach((item, index) => { images[item.replace('./', '')] = r(item); });
      return images;
    }
    const images = importAll(require.context('./images/',false,/\.(png|jpe?g|gif)$/));

    // The header contains a Google button that updates state with credential and user ID
    // https://developers.google.com/identity/gsi/web/reference/html-reference#element_with_id_g_id_onload
    const googleButton = (
      <div>
        <div id="g_id_onload"
          data-client_id="235022023955-tll203hk1otnjji8ih27lnj5hcvms51l.apps.googleusercontent.com"
          data-callback="google_login"
          data-color_scheme="dark"
          data-auto_prompt="true">
        </div>
        <div className="g_id_signin"
          data-auto_select="true"
          data-type="standard"
          data-size="small"
          data-theme="filled_black"
          data-text="sign_in_with"
          data-shape="rectangular"
          data-logo_alignment="left"
          data-width="100">
        </div>
        {
          // https://developers.google.com/identity/gsi/web/reference/js-reference#google.accounts.id.revoke
          this.state.credential &&
          <button onClick={()=>{
            window.google.accounts.id.revoke(this.state.sub, done => {
              window.location.reload();
            });
          }}> &#x1F6AA; Sign out</button>
        }
      </div>
    );
    
    const header = (
      <div id='header' className='header'>
        <div className='header-inner'>
          <div id='google-login'>
            {this.state.headerBtnVisible ? googleButton : null}
            <div>
              <a href="https://moreygenetics.com/instructions">
                <span role="img" aria-label="(info)">&#x2139;&#xfe0f;</span>&nbsp;
                Authentication, file upload,<br/>and deletion instructions
              </a>
            </div>
            <a href="mailto:kevin.a.morey@gmail.com" style={{position:"absolute",right:"3px",top:"3px",fontSize:"25px"}}>
              <span role='img' aria-label='email'>&#128231;</span>
            </a>
          </div>
        </div>
      </div>
    );

    // Create the category list using the json file "List"
    let List = this.state.list;
    let category_list = [];
    let keys = Object.keys(List);
    
    for (var i=0;i<keys.length;i++){
      // Get a logo from each category's "img" or "emoji" property
      let img = "";
      if (Object.keys(List[keys[i]]).includes("emoji")) {
        img = <span>{List[keys[i]]["emoji"]}</span>;
        if (List[keys[i]]["emoji"]===String.fromCodePoint(0x1f318)&&this.state.moonPhase) img = this.state.moonPhase;
      } else if (Object.keys(List[keys[i]]).includes("img")) {
        img = <img src={images[List[keys[i]]["img"]]} alt=""></img>
      }

      // Add an "a" tag that contains the logo and title for each category
      category_list.push(
        <a href={'/a/'+encodeURIComponent(keys[i])}
          key={keys[i]}>
          <div className='cat'>
            <div className='icon'>{img}</div>
            <div className='title'>{keys[i]}</div>
          </div>
        </a>
      )
    }
  
    return (
      <>
        {header}
        <div id="center">
          <Router>
            <Route exact path={process.env.PUBLIC_URL+"/"}
              render={
                ()=>(
                  //this.state.listLoaded &&
                  //<Google sub={this.state.sub} credential={this.state.credential}/>
                  this.state.listLoaded && 
                  <>
                    <Disclaimers/>
                    {category_list}
                  </>
                  
                  //<Google
                  //  credential={this.state.credential}
                  //  googleButton={googleButton}
                  //  headerBtnVisible={this.state.headerBtnVisible}
                  //  removeHeaderBtn={this.removeHeaderBtn}
                  ///>
                    // <Category id={"Cardiomyopathies and chronic heart failure"} info={List[decodeURIComponent("Cardiomyopathies and chronic heart failure")]} sub={this.state.sub} credential={this.state.credential} />
                    //<Facebook2/>
                )
              }
            />
            <Route exact path={process.env.PUBLIC_URL+"/a/:id"}
              render={
                ({match}) => (
                  this.state.listLoaded && keys.includes(decodeURIComponent(match.params.id)) &&
                  <>
                    <a href='https://moreygenetics.com'>
                      <span style={{fontSize:'35px'}}>&#x1F844;</span>
                    </a>
                    <Disclaimers/>
                    <Category id={match.params.id} info={List[decodeURIComponent(match.params.id)]} credential={this.state.credential} sub={this.state.sub} />
                  </>
                )
              }
            />
            <Route exact path={process.env.PUBLIC_URL+"/docs"}
              render={
                ()=>(
                  this.state.listLoaded &&
                  <Docs/>
                )
              }
            />
            <Route exact path={process.env.PUBLIC_URL+"/instructions"}
              render={
                ()=>(
                  this.state.listLoaded &&
                  <Google
                    credential={this.state.credential}
                    googleButton={googleButton}
                    headerBtnVisible={this.state.headerBtnVisible}
                    removeHeaderBtn={this.removeHeaderBtn}
                  />
                )
              }
            />
          </Router>
        </div>
      </>
    )
  }
}

export default App;
